'use strict';

var lodash = require('lodash');
var constants = require('../constants.cjs.js');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var lodash__default = /*#__PURE__*/_interopDefaultCompat(lodash);

class DefaultNamespaceEntityPolicy {
  namespace;
  constructor(namespace = constants.DEFAULT_NAMESPACE) {
    this.namespace = namespace;
  }
  async enforce(entity) {
    if (entity.metadata.namespace) {
      return entity;
    }
    return lodash__default.default.merge({ metadata: { namespace: this.namespace } }, entity);
  }
}

exports.DefaultNamespaceEntityPolicy = DefaultNamespaceEntityPolicy;
//# sourceMappingURL=DefaultNamespaceEntityPolicy.cjs.js.map
